import { render, staticRenderFns } from "./RecruitingHomeIntroVideo.vue?vue&type=template&id=04d48c19&scoped=true"
import script from "./RecruitingHomeIntroVideo.vue?vue&type=script&lang=js"
export * from "./RecruitingHomeIntroVideo.vue?vue&type=script&lang=js"
import style0 from "./RecruitingHomeIntroVideo.vue?vue&type=style&index=0&id=04d48c19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d48c19",
  null
  
)

export default component.exports